import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=45ac0592&scoped=true&"
import script from "./adminList.vue?vue&type=script&lang=js&"
export * from "./adminList.vue?vue&type=script&lang=js&"
import style0 from "./adminList.vue?vue&type=style&index=0&id=45ac0592&scoped=true&lang=css&"
import style1 from "./adminList.vue?vue&type=style&index=1&id=45ac0592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac0592",
  null
  
)

export default component.exports